var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseThin = function SvgCloseThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 1,
    x: 0.707,
    rx: 0.5,
    transform: "rotate(45 .707 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 1,
    y: 11.313,
    rx: 0.5,
    transform: "rotate(-45 0 11.313)"
  }))));
};
export default SvgCloseThin;